import { BaseDeliveryAddress } from '~/features/checkout/models/fields';
import { ShippingMethod } from '~/lib/data-contract/salesforce';

export const selectedCarrierHasDeliveryAddress = (c: ShippingMethod, a: BaseDeliveryAddress) => {
    return a.carrier?.id === c?.id;
};

export const getDroppointDeliveryAddress = (s: ShippingMethod, a: BaseDeliveryAddress) => {
    const result = a.carrier?.id === s?.id;
    return result ? a : null;
};
